import { Facebook, Instagram } from "lucide-mui"
import React from "react"

import { TikTokIcon } from "@/shared/tiktok_icon"
import { XIcon } from "@/shared/x_icon"

interface VenueSocialAccountsProps {
  socialAccounts?: Record<string, string> | null
}

const VenueSocialAccounts: React.FC<VenueSocialAccountsProps> = ({ socialAccounts }) => {
  const hasSocialAccounts = socialAccounts && Object.keys(socialAccounts).length > 0

  if (!hasSocialAccounts) return null

  return (
    <div id="venue-social" data-testid="public-venue-social-container">
      <div className="flex items-end gap-4 leading-none">
        {socialAccounts?.facebook ? (
          <a
            href={socialAccounts.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-gray-600 hover:text-blue-600 transition-colors"
            aria-label="Facebook"
            data-testid="public-venue-social-link-facebook"
          >
            <Facebook className="w-5 h-5" />
          </a>
        ) : null}
        {socialAccounts?.instagram ? (
          <a
            href={socialAccounts.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-gray-600 hover:text-pink-600 transition-colors"
            aria-label="Instagram"
            data-testid="public-venue-social-link-instagram"
          >
            <Instagram className="w-5 h-5" />
          </a>
        ) : null}
        {socialAccounts?.x ? (
          <a
            href={socialAccounts.x}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-gray-600 hover:text-black transition-colors"
            aria-label="X"
            data-testid="public-venue-social-link-x"
          >
            <XIcon className="w-5 h-5" />
          </a>
        ) : null}
        {socialAccounts?.tiktok ? (
          <a
            href={socialAccounts.tiktok}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-gray-600 hover:text-black transition-colors"
            aria-label="TikTok"
            data-testid="public-venue-social-link-tiktok"
          >
            <TikTokIcon className="w-5 h-5" />
          </a>
        ) : null}
      </div>
    </div>
  )
}

export default VenueSocialAccounts
